import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from 'react-bootstrap';
import "./Header.css";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../../../Utils/AuthProvider";
import Swal from "sweetalert2";
import { adminChangepassword } from "../../../../services/CommonService";

const Header = () => {
  const navigate = useNavigate();
  const [adminData, setadminData] = useState([]);
  const [validated, setValidated] = useState(false);
  const { logout } = useAuth();
  const [errors, setErrors] = useState({});
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Fetch existing projects data
  useEffect(() => {
    const intervalId = setInterval(() => {
      const admindata = localStorage.getItem('admin');
      if (admindata) {
        try {
          const parsed = JSON.parse(admindata);
          if (parsed) {
            setadminData(parsed);
            clearInterval(intervalId); // ✅ Stop polling once data is found and set
          } else {
            console.error('');
          }
        } catch (e) {
          console.error('Invalid JSON in menuData:', e);
        }
      }
    }, 500); // 🔁 Check every 500ms
  }, []);

  useEffect(() => {
    if (errors.confirmPassword) {
      validate();
    }
    if (errors.oldPassword) { validate(); }
  }, [confirmPassword, oldPassword]); // run when confirmPassword changes

  const validate = () => {
    const newErrors = {};
    const passwordRegex = /^(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-])[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]{6,15}$/;

    if (!oldPassword.trim()) {
      newErrors.oldPassword = "Old password is required";
    }

    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (!passwordRegex.test(newPassword)) {
      newErrors.newPassword = "Password must be 6-15 characters and include at least one special character";
    } else if (newPassword === oldPassword) {
      newErrors.newPassword = "New password must be different from the old password";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setValidated(true);
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();

    setValidated(true); // this enables native HTML5 validation

    if (!oldPassword || !newPassword || !confirmPassword) {
      return; // Prevent API call and keep modal open if fields are empty
    }

    if (newPassword !== confirmPassword) {
      setPasswordError("New and Confirm passwords do not match");
      return; // Keep modal open
    }

    if (validate()) {
      setPasswordError('');
      try {
        const newload = {
          user_id: adminData?.user?.id,
          old_password: oldPassword,
          new_password: newPassword,
          new_password_confirmation: newPassword,
        };
        const response = await adminChangepassword(newload);
        const data = await response.data;

        if (data) {
          Swal.fire({
            title: "Password changed successfully",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          });
          // ✅ Clear and close modal after successful change
          setOldPassword('');
          setNewPassword('');
          setConfirmPassword('');
          setShowChangePasswordModal(false);
          setValidated(false);
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: error?.response?.data?.message || error?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };


  const logoutuser = () => {
    Swal.fire({
      title: "Are you want logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok"
    }).then(async (result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        sessionStorage.clear();
        logout();
        navigate('/admin/administrator', { replace: true });
      }
    });
  };

  return (
    <>
      <Modal show={showChangePasswordModal} onHide={() => setShowChangePasswordModal(false)} centered>
        <Modal.Header closeButton style={{ backgroundColor: '#28186f', color: 'white' }}>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleChangePasswordSubmit} noValidate validated={validated}>
            <Form.Group className="mb-3" style={{ position: 'relative' }}>
              <Form.Label>
                Old Password <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type={showOldPassword ? 'text' : 'password'}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                isInvalid={!!errors.oldPassword}
              />
              <button
                type="button"
                onClick={() => setShowOldPassword(!showOldPassword)}
                style={{
                  position: 'absolute',
                  top: '42px',
                  right: '10px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#888',
                }}
              >
                <i className={`bi ${errors.oldPassword ? 'bi-invalid' : ''} ${showOldPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
              </button>
              <Form.Control.Feedback type="invalid">
                {errors.oldPassword}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" style={{ position: 'relative' }}>
              <Form.Label>
                New Password <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type={showNewPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  validate(); // real-time check
                }}
                isInvalid={!!errors.newPassword}
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                style={{
                  position: 'absolute',
                  top: '42px',
                  right: '10px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#888',
                }}
              >
                <i className={`bi ${errors.newPassword ? 'bi-invalid' : ''} ${showNewPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
              </button>
              <Form.Control.Feedback type="invalid">
                {errors.newPassword}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" style={{ position: 'relative' }}>
              <Form.Label>
                Confirm Password <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  if (errors.confirmPassword) validate();
                }}
                isInvalid={!!errors.confirmPassword}
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: 'absolute',
                  top: '42px',
                  right: '10px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#888',
                }}
              >
                <i className={`bi ${errors.confirmPassword ? 'bi-invalid' : ''} ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
              </button>
              <Form.Control.Feedback type="invalid">
                {errors.confirmPassword}
              </Form.Control.Feedback>
            </Form.Group>
            <div className="text-end">
              <Button variant="secondary" onClick={() => setShowChangePasswordModal(false)}>Cancel</Button>{' '}
              <Button variant="primary" type="submit" disabled={!validated}>Change Password</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="layout">
        <div className="content-area">
          <div className="header-page">
            <img src="/logo1.png" alt="ACWADAM Logo" className="logos" />
            <div className="user-section d-flex">
              {/* <div className="mt-2 me-3">Admin</div>  */}
              <div className="avatar-placeholder">
                <span>{adminData?.user?.email?.[0]?.toUpperCase()}</span>
              </div>
              <div className="dropdown-menu">
                <ul>
                  <li>{adminData?.user?.email}</li>
                  {/* <li onClick={handleForgotPassword}>Change Password</li> */}
                  <li onClick={() => setShowChangePasswordModal(true)}>Change Password</li>
                  <li onClick={() => { logoutuser() }}>Logout</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="main-content"></div>
        </div>
      </div>
    </>
  );
};

export default Header;
